const homeStoresSlider = {
  initializeSlider: () => {
    $(".themeHomeStores__contents").slick({
      infinite: true,
      slidesToShow: 3,
      arrows: true,
      dots: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
  init: () => {
    homeStoresSlider.initializeSlider();
  },
};

export default homeStoresSlider;
